import { Button, Grid2 as Grid } from "@mui/material";
import { useStyles } from "../../Search.styles";
import { buttonMessage } from "../../constants";
import React from "react";
type SearchButtonProps = {
	onSearch: () => void;
};

export const SearchButton = ({ onSearch }: SearchButtonProps) => {
	const classes = useStyles();
	const searchButtonRef = React.useRef<HTMLButtonElement>(null);

	return (
		<Grid size={{ xs: 3, sm: 2, md: 1 }}>
			<Button
				variant="contained"
				color="primary"
				onClick={onSearch}
				className={classes.searchButton}
				ref={searchButtonRef}
				fullWidth
			>
				{buttonMessage}
			</Button>
		</Grid>
	);
};
